import React from "react";
import Hexagon from "../asset/hexagon.svg";
import Terminal from "../asset/terminal2.png";
import Hacker from "../asset/hacker-cover.webp";
import Drop from "../asset/drop.gif";
import Lead from "../asset/lead.webp";

const HomeStatic = () => {
  return (
    <div className="container">
      <img src={Hexagon} alt="example-svg" className="svghexa-color" />
      <img src={Hexagon} alt="example-svg" className="svghexa-color-combine" />

      <div className="pt-4 row pb-4">
        <div className="col-12 col-md-6 left pb-2">
          <div className="content col-md-11 col-12">
            <h1 className="font-PoppinsBold">
              Boyz with a bit of <span className="font-green">code, </span> some{" "}
              <span className="font-green">pentest,</span> and random{" "}
              <span className="font-green">articles.</span>
            </h1>
            <div className="text pb-2 text-wrap">
              <p>
                <b>Hey, I’m Azfar. </b>
                <br />
                ’Im into a bit of coding, some light pentesting, and sometimes
                just random stuff. This page is kinda like my life diary,
                sharing a little bit of knowledge, and maybe some future plans
                (if I’m feeling productive 😅). So if I suddenly get some random
                ideas, just bear with me, guys.
              </p>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-6 right">
          <img src={Terminal} className="img-fluid" alt="Responsive" />
        </div>
      </div>

      <div className="second-content pb-4">
        <h1 className="text-center font-PoppinsSemi pb-5">
          Some random <span className="font-green">articles</span> on here ....
        </h1>

        <div className="nav-content shadow-sm p-3 mb-5">
          <div className="col-12 isi-content position-relative">
            <div className="row">
              <div className="col-12 col-md-4 mb-3 ">
                <div className="h-100 card-articles">
                  <img src={Lead} className="card-img-top pb-2" alt="example" />
                  <div className="card-body">
                    <h6 className="card-title pb-1 pt-1 font-PoppinsBold">
                      Mencoba Jadi <span className="font-green">Team Lead</span>{" "}
                      Dalam Satu Bulan 👾.
                    </h6>
                    <p className="card-text text-grey clamp-2-lines">
                      Di suatu hari yang tidak terduga, saya seorang anomali, dipercaya untuk menjadi Team Lead dalam kurang waktu 1 bulan, apa yang terjadi :u ?
                    </p>

                    <a href="/mencoba-jadi-team-lead-satu-bulan">
                      <button className="btn btn-sm btn-base">Read</button>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-4 mb-3 ">
                <div className="h-100 card-articles">
                  <img src={Drop} className="card-img-top pb-2" alt="example" />
                  <div className="card-body">
                    <h6 className="card-title pb-1 pt-1 font-PoppinsBold">
                      Drop <span className="font-green">Javascript</span>{" "}
                      Phising On Windows 😃.
                    </h6>
                    <p className="card-text text-grey clamp-2-lines">
                      Mungkin yang kalian tau javascript running di content web
                      ? bagaimana javascript berjalan pada windows, dan justru
                      membuat malware yang mengatantarkan phising attack ?
                    </p>

                    <a href="/drop-js-phising-on-windows">
                      <button className="btn btn-sm btn-base">Read</button>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-4 mb-3 ">
                <div className="h-100 card-articles">
                  <img
                    src={Hacker}
                    className="card-img-top pb-2"
                    alt="example"
                  />
                  <div className="card-body">
                    <h6 className="card-title pb-1 pt-1 font-PoppinsBold">
                      Jadi <span className="font-green">Hacker</span> Kaya Di
                      film-film 👽.
                    </h6>
                    <p className="card-text text-grey clamp-2-lines">
                      Tidak pernah terfikir saya melakukan apa yang hacker
                      lakukan di film-film, tapi in real life.
                    </p>

                    <a href="/jadi-hacker-kaya-di-film">
                      <button className="btn btn-sm btn-base">Read</button>
                    </a>
                  </div>
                </div>
              </div>
              
            </div>
          </div>
        </div>

        <div className="pagination d-flex justify-content-center">
          <span className="mx-3">
            <a href="/articles">
              <button className="btn btn-sm btn-base ">View More</button>
            </a>
          </span>
        </div>
      </div>
    </div>
  );
};

export default HomeStatic;
